<template>
  <div class="tel-success">
    <div class="success-img">
      <img src="@/assets/images/tel_submit.png" alt="" />
    </div>
    <p>已提交</p>
    <p @click="openResult" class="blue-text">查看提交结果</p>
    <van-dialog v-model="show" title="提交结果" @confirm="show = false">
      <p class="dialog-text">招生系统{{ changeType[status] }}</p>
    </van-dialog>
  </div>
</template>
<script>
import { Toast } from "vant";
import { queryZsStatus } from "@/server/api.js";
import { addressBar } from "@/utils/public.js";
export default {
  data() {
    return {
      userId: "",
      show: false,
      status: "",
      externalUserid: "",
      changeType: {
        1: "未同步成功",
        4: "同步失败",
        5: "同步没返回结果",
        2: "入库成功",
        3: "重量",
      },
    };
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.userId = localStorage.getItem("userid");
      this.externalUserid = this.$route.query.externalUserid;
    } else {
      addressBar("token", this.windowurl);
    }
  },
  methods: {
    openResult() {
      this.show = true;
      queryZsStatus({
        externalUserId: this.externalUserid,
        uid: this.userId,
      }).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        this.status = res.data;
      });
    },
  },
};
</script>
<style scoped lang="less">
.tel-success {
  text-align: center;
  .success-img {
    padding-top: 35%;
    margin-bottom: 10px;
    img {
      width: 200px;
      height: 200px;
    }
  }
  p {
    font-size: 28px;
  }
  .blue-text {
    color: #277fff;
    margin-top: 50px;
    cursor: pointer;
  }
  .dialog-text {
    padding: 10px 0 20px;
  }
}
</style>
